export default __webpack_public_path__ + "static/media/bank-transfer.9b25a7ce.svg";